<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Task Cloning') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Task cloning allows you to create multiple copies of a task with different due dates. This is useful for recurring tasks, weekly reviews, or tasks that need to be repeated at regular intervals.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  "ProjectSettings|When enabled, you can clone an existing task to create one or more copies. During cloning, you can specify different due dates for each copy, allowing you to schedule the same task for multiple time periods. The cloned tasks retain the original task's structure, description, and settings, but can be customized independently."
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Use Cases') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|Weekly or monthly recurring tasks (e.g., team standups, reports)'
                  )
                }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|Tasks that need to be performed across multiple time periods'
                  )
                }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|Creating task series with similar structure but different deadlines'
                  )
                }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|Scheduling the same work for different team members or projects'
                  )
                }}
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
